import { render, staticRenderFns } from "./AxMessageModal.vue?vue&type=template&id=13e1b8be&scoped=true"
import script from "./AxMessageModal.vue?vue&type=script&lang=ts"
export * from "./AxMessageModal.vue?vue&type=script&lang=ts"
import style0 from "./AxMessageModal.vue?vue&type=style&index=0&id=13e1b8be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e1b8be",
  null
  
)

export default component.exports